// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"rZ-z","subtitle":"sZ-z","wrapper":"tZ-z","leftArrow":"uZ-z","rightArrow":"vZ-z"};